var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "previewCode" },
    [
      _c(
        "div",
        { staticClass: "previewCodeTool" },
        [
          _c("p", [_vm._v("操作栏：")]),
          _c("el-button", { on: { click: _vm.selectText } }, [_vm._v("全选")]),
          _c("el-button", { on: { click: _vm.copy } }, [_vm._v("复制")])
        ],
        1
      ),
      _c(
        "el-tabs",
        {
          model: {
            value: _vm.activeName,
            callback: function($$v) {
              _vm.activeName = $$v
            },
            expression: "activeName"
          }
        },
        _vm._l(_vm.previewCode, function(item, key) {
          return _c(
            "el-tab-pane",
            { key: key, attrs: { label: key, name: key } },
            [_c("div", { staticClass: "tab-info", attrs: { id: key } })]
          )
        }),
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }